import { createRouter, createWebHashHistory } from 'vue-router';
import Report from '../pages/report/Report.vue';
import Chat from '../pages/create/Chat.vue';
import { loadI18n } from '@/infrastructure/locales';

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            redirect: '/chat',
            beforeEnter: async(to, from, next) => {
                await loadI18n();
                next();
            },
            children: [
                {
                    path: 'report/:projectId',
                    name: 'report',
                    component: Report,
                }, {
                    path: 'chat',
                    name: 'chat',
                    component: Chat,
                }, {
                    path: 'chat/:projectId',
                    name: 'chatDetail',
                    component: Chat,
                }
            ],
        }
    ],
})

export default router
